"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Desktop", {
  enumerable: true,
  get: function get() {
    return _desktop.default;
  }
});
Object.defineProperty(exports, "Mobile", {
  enumerable: true,
  get: function get() {
    return _mobile.default;
  }
});
Object.defineProperty(exports, "Tablet", {
  enumerable: true,
  get: function get() {
    return _tablet.default;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _desktop = _interopRequireDefault(require("./desktop"));
var _tablet = _interopRequireDefault(require("./tablet"));
var _mobile = _interopRequireDefault(require("./mobile"));
var Breakpoint = function Breakpoint(_ref) {
  var children = _ref.children,
    direction = _ref.direction,
    breakpoint = _ref.breakpoint;
  var theme = (0, _styles.useTheme)();
  var isBreakpoint = (0, _core.useMediaQuery)(theme.breakpoints[direction](breakpoint));
  return isBreakpoint && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
Breakpoint.propTypes = {
  children: _propTypes.default.node,
  direction: _propTypes.default.oneOf(['only', 'up', 'down']),
  breakpoint: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
Breakpoint.defaultProps = {
  children: null,
  direction: 'up',
  breakpoint: 'xs'
};
var _default = Breakpoint;
exports.default = _default;